import { Injectable } from '@angular/core';

import { IMenuItem } from './menu-item';
import { MENUITEMS,MENUITEMS1,MENUITEMS2,MENUITEMS3,MENUITEMS4,MENUITEMS5,MENUITEMS6 } from './mock-menu-items';
import { MENU } from '../../../settings/menu';

@Injectable()
export class MenuService {
  getMenuItems(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS);
  }
  getMenuItems1(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS1);
  }
  getMenuItems2(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS2);
  }
  getMenuItems3(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS3);
  }
  getMenuItems4(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS4);
  }
  getMenuItems5(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS5);
  }
  getMenuItems6(): Promise<IMenuItem[]> {
    return Promise.resolve(MENUITEMS6);
  }
}


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/menu/menu.service.ts